/* eslint-disable */
import React from 'react';
import Text, { TextLink } from '@lightspeed/cirrus-text';
import { Tooltip } from '@lightspeed/flame/Tooltip';
import cn from 'classnames';

const baseClass = 'retail-listing__cell';

export class LeftRightItem extends React.Component {
  render() {
    const { notranslate } = this.props;
    const classNames = cn(`${baseClass}--left-right`);
    const textItemClassNames = cn(notranslate && 'notranslated');

    return (
      <td className={baseClass}>
        <div className={classNames}>
          <Text bodySmall bold>
            {this.props.left || ''}
          </Text>
          <TextItem
            value={this.props.right}
            href={this.props.href}
            id={this.props.id}
            className={textItemClassNames}
          />
        </div>
      </td>
    );
  }
}

export class TopBottomItem extends React.Component {
  render() {
    const { notranslate, small } = this.props;
    const classNames = cn(
      `${baseClass}__top-bottom`,
      small && `${baseClass}__top-bottom--small`,
      notranslate && 'notranslate'
    );

    return (
      <td className={baseClass}>
        <div className={classNames}>
          <Text bodySmall bold>
            {this.props.top || ''}
          </Text>
          <Text heading2={!small} bodySmall={small} bold={!small}>
            {this.props.bottom || ''}
          </Text>
        </div>
      </td>
    );
  }
}

export class ImageItem extends React.Component {
  render() {
    const classNames = cn(baseClass, `${baseClass}--image`);

    return (
      <td className={classNames}>
        <img src={this.props.imageLink} alt="" />
      </td>
    );
  }
}

export class TextAreaItem extends React.Component {
  render() {
    const classNames = cn(baseClass, `${baseClass}--text-area`);

    return (
      <td className={classNames}>
        <textarea rows="15" readOnly {...this.props} />
      </td>
    );
  }
}

export class TextItem extends React.Component {
  render() {
    let content = this.props.value;
    const { href, id, className } = this.props;
    const classNames = cn(`${baseClass}__item-text`, className);

    content = content || '';
    if (href && id && !isNaN(id) && parseInt(id) > 0) {
      content = (
        <TextLink href={href + id} bold>
          {content}
        </TextLink>
      );
    } else {
      content = (
        <Tooltip content={content}>
          <div className={`${baseClass}__item-text-value`}>{content}</div>
        </Tooltip>
      );
    }

    return (
      <Text bodySmall className={classNames} element="div">
        {content}
      </Text>
    );
  }
}
